import {Navigate, Route, Routes} from 'react-router-dom';
import {AgentsPage} from "../pages/privatePages/AgentsPage";
import {NavItem} from "../types";
import { AgentFilesPage } from "../pages/privatePages/AgentFilesPage";
import {AgentPage} from "../pages/privatePages/AgentPage";
import {BarChart, Chat, FileUpload, Settings} from '@mui/icons-material';
import MaiLayout from "../components/layout/MaiLayout";
import {ChatAnalysisPage} from "../pages/privatePages/ChatAnalysisPage";
import {LiveViewPage} from "../pages/privatePages/LiveViewPage";
import {MessengerActivationPage} from "../pages/privatePages/MessengerActivationPage";
import {AdminPage} from "../pages/privatePages/AdminPage";

const navItems: NavItem[]= [
    {
        path: '/settings',
        titel: "Einstellungen",
        icon: <Settings />,
        element: <AgentPage />
    },
    {
        path: '/files',
        titel: "Dateien",
        icon: <FileUpload />,
        element: <AgentFilesPage />
    },
    {
        path: '/sessions',
        titel: "Chat-Analyse",
        icon: <BarChart />,
        element: <ChatAnalysisPage />
    },
    {
        path: '/live',
        titel: "Liveansicht",
        icon: <Chat />,
        element: <LiveViewPage />
    }
]

export const PrivateRoutes = () => {
    return (
        <MaiLayout navItems={navItems}>
            <Routes>
                {navItems.map((navItem) => <Route path={navItem.path} element={navItem.element} key={navItem.titel}/>)}
                <Route path="/agents" element={<AgentsPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/messenger-activation/:agent-id" element={<MessengerActivationPage />} />
                <Route path='*' element={<Navigate to='/agents' replace />} />
            </Routes>
        </MaiLayout>
    );
};
